var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.6569 25.3773C27.6569 28.9829 22.3612 30.6736 15.8284 30.6736C9.29571 30.6736 4 28.766 4 25.3773C4 18.8445 9.29571 13.5488 15.8284 13.5488C22.3612 13.5488 27.6569 18.8445 27.6569 25.3773Z",
    fill: "#3E5BD5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.6557 25.3791C27.6557 28.9847 22.3599 30.6755 15.8272 30.6755C10.9642 30.6755 6.78652 29.6184 4.96875 27.6801C7.09653 28.5409 9.99244 28.9962 13.1837 28.9962C19.7164 28.9962 25.0121 27.3056 25.0121 23.7C25.0121 20.0614 23.3693 16.8067 20.7849 14.6367C24.8412 16.5116 27.6557 20.6167 27.6557 25.3791Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.8275 16.9831C20.2411 16.9831 23.819 13.4051 23.819 8.99154C23.819 4.57793 20.2411 1 15.8275 1C11.4139 1 7.83594 4.57793 7.83594 8.99154C7.83594 13.4051 11.4139 16.9831 15.8275 16.9831Z",
    fill: "#3E5BD5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.822 8.99218C23.822 13.4058 20.2439 16.9839 15.8303 16.9839C12.043 16.9839 8.87069 14.3492 8.04688 10.8125C9.25233 13.2737 11.7819 14.9685 14.7072 14.9685C18.801 14.9685 22.1196 11.6499 22.1196 7.55622C22.1196 5.2752 21.0893 3.23482 19.4686 1.875C22.0532 3.19861 23.822 5.8888 23.822 8.99218Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.8864 6.20276C11.5852 7.50383 10.6934 8.72184 9.84627 7.87485C8.99911 7.0277 9.36724 5.28607 10.6685 3.98484C11.9697 2.68376 13.7112 2.31548 14.5583 3.16263C15.4056 4.00962 14.1876 4.90153 12.8864 6.20276Z",
    fill: "#6078E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10.4176 20.3004C9.11641 21.6015 8.22467 22.8195 7.37752 21.9725C6.53036 21.1254 6.89849 19.3837 8.19972 18.0825C9.50095 16.7814 11.2424 16.4131 12.0896 17.2603C12.9367 18.1073 11.7189 18.9992 10.4176 20.3004Z",
    fill: "#6078E1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.38b6537438590e542228d777020c6d66.svg";
export { ForwardRef as ReactComponent };